import { useMemo } from 'react';
import { type MenuItemLink } from '@direct-frontend/components';
import { type OpenApiSchemaAddonListItem } from '#shared/api/schema';
import { addonsEditRoute } from '#shared/lib/routes';

export const useActionEdit = (addonId: OpenApiSchemaAddonListItem['id']) => {
    const menuItem = useMemo<MenuItemLink<'edit'>>(() => {
        return {
            content: 'Редактировать',
            key: 'edit',
            url: addonsEditRoute.getUrl({ params: { addonId } }),
        };
    }, [addonId]);

    return { menuItem };
};
